module.exports = "./img/27c68dba22a30b90734153192a0ffb6c.jpg";